import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var MediaBrowser = createReactClass({
  propTypes: {
    path: PropTypes.array,
    disabled: PropTypes.bool,
    search: PropTypes.string,
  },

  getDefaultProps: function() {
    return {
      path: [],
      handleChangeSearch: () => {},
      search: null,
      disabled: false,
    };
  },

  render: function() {
    let path;
    this.props.path.length > 0 ? (path = '') : (path = '/');
    this.props.path.forEach(element => {
      if (element !== '/') {
        path += '/' + element;
      }
    });

    return (
      <div className="path-panel">
        <span>{path}</span>
        <div>
          <input
            className="form-control"
            style={{ width: 'initial' }}
            placeholder="Vyhľadávať obrázok"
            value={this.props.search ? this.props.search : ''}
            disabled={this.props.disabled}
            onChange={this.props.onChangeSearch}
          />
        </div>
      </div>
    );
  },
});

export default MediaBrowser;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/PathPanel.jsx